import { render, staticRenderFns } from "./notifications-item.vue?vue&type=template&id=325a6840&scoped=true"
import script from "./notifications-item.vue?vue&type=script&lang=js"
export * from "./notifications-item.vue?vue&type=script&lang=js"
import style0 from "./notifications-item.vue?vue&type=style&index=0&id=325a6840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325a6840",
  null
  
)

export default component.exports